import { api } from "api/api";
import { FormValues } from "hooks/bookAppointmentOnline/useBookAppointmentOnline.hook";

export default async function bookAppointmentOnline({
    date,
    time,
    firstName,
    lastName,
    phoneNumber,
    typeId,
    doctorId,
    agreementConsent,
    personalDataConsent,
    marketingConsent,
    addToCalendar,
}: FormValues) {
    const url = 'api/public/book/appointment/online/book';
    const datetime = date.replace(/ .*/, ` ${time}`);
    const response = await api.post(url, {
        datetime,
        firstName,
        lastName,
        phoneNumber,
        typeId,
        doctorId,
        agreementConsent,
        personalDataConsent,
        marketingConsent,
        addToCalendar,
    });
    return response.data.data;
};
